import { render, staticRenderFns } from "./CreditGame.vue?vue&type=template&id=29a3f6f2&scoped=true"
import script from "./CreditGame.vue?vue&type=script&lang=js"
export * from "./CreditGame.vue?vue&type=script&lang=js"
import style0 from "./CreditGame.vue?vue&type=style&index=0&id=29a3f6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a3f6f2",
  null
  
)

export default component.exports